import { parseSSE } from "@qn/providers";
import { toApiError } from "./api";

export type ChatStreamEvent =
  | {
      event: "meta";
      data: { conversationId: string; userMessageId: string; assistantMessageId: string };
    }
  | { event: "start"; data: { providerId: string; providerName: string; model: string } }
  | {
      event: "fallback";
      data: {
        fromProviderId: string;
        fromModel: string;
        toProviderId: string;
        toModel: string;
        reason: string;
      };
    }
  | { event: "text"; data: { delta: string } }
  | { event: "thinking"; data: { delta: string } }
  | { event: "usage"; data: { inputTokens: number; outputTokens: number; costUsd: number } }
  | { event: "error"; data: { message: string; status?: number } }
  | {
      event: "done";
      data: { stopReason: string; status: string; messageId: string; title?: string };
    };

export async function* streamChat(
  conversationId: string,
  body: Record<string, unknown>,
  signal: AbortSignal,
): AsyncGenerator<ChatStreamEvent> {
  const res = await fetch(`/api/conversations/${conversationId}/messages`, {
    method: "POST",
    credentials: "same-origin",
    signal,
    headers: { "content-type": "application/json", "x-qn-client": "web" },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) throw await toApiError(res);
  for await (const m of parseSSE(res.body)) {
    try {
      yield { event: m.event, data: JSON.parse(m.data) } as ChatStreamEvent;
    } catch {
      /* ignore malformed frame */
    }
  }
}
